export default "__VITE_ASSET__Bgp1AE$y__";